var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e-loader__container"},[_c('div',{staticClass:"e-loader static"}),_c('div',{staticClass:"e-loader animated"})])
}]

export { render, staticRenderFns }